import React from 'react'
import { poweredBySvg } from './svgs'

export interface PoweredByLogoProps {
  width?: number
  height?: number
  viewBox?: string
}

export const PoweredByLogo: React.FC<PoweredByLogoProps> = ({
  width = 96,
  height = 36,
  viewBox = '0 0 120 40'
}) => (
  <svg
    aria-labelledby='powered-by-logo'
    role='img'
    viewBox={viewBox}
    width={width}
    height={height}
  >
    <title id='powered-by-logo'>Powered by Alternative Payments</title>
    {poweredBySvg.map(svg => (
      <path {...svg} key={svg.d} />
    ))}
  </svg>
)
